import { useId, useRef } from 'react';

import { DialogShell } from '../../components/DialogShell';

interface LockedComposerDialogProps {
  readonly onClose: () => void;
}

export function LockedComposerDialog({ onClose }: LockedComposerDialogProps) {
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);
  const titleId = useId();
  const descriptionId = useId();

  return (
    <DialogShell
      className="new-map-dialog locked-composer-dialog"
      descriptionId={descriptionId}
      initialFocusRef={closeButtonRef}
      onClose={onClose}
      titleId={titleId}
    >
      <h2 id={titleId}>Composer is available with Placeio Maps Pro</h2>
      <p id={descriptionId}>
        Create polished map layouts with titles, legends, scale bars and north arrows, then export
        them as PNG or PDF.
      </p>
      <div className="new-map-dialog-actions">
        <button className="primary-action" onClick={onClose} ref={closeButtonRef} type="button">
          Close
        </button>
      </div>
    </DialogShell>
  );
}
